import { Row, Col, ListGroup, Image, Form, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { FaTrash } from 'react-icons/fa';
import Message from '../Message';
import SectionTitle from './SectionTitle';
import { formatNTD } from '../../utils/pricing';
import { addToCart, removeFromCart } from '../../slices/cartSlice';

// Cart section: same qty-select + remove behavior as CartScreen, but inline.
// UI polish: xs column widths so rows stay compact on phones, plus a footer
// with the running subtotal and a "Continue to Shipping" jump button.
const CartSection = ({ scrollTo }) => {
  const dispatch = useDispatch();
  const { cartItems, itemsPrice } = useSelector((state) => state.cart);

  const itemCount = cartItems.reduce((acc, item) => acc + item.qty, 0);

  const updateQtyHandler = (product, qty) => {
    dispatch(addToCart({ ...product, qty }));
  };

  const removeHandler = (id) => {
    dispatch(removeFromCart(id));
  };

  return (
    <>
      <SectionTitle step={2}>購物車</SectionTitle>
      {cartItems.length === 0 ? (
        <Message>購物車是空的，先從上方挑選商品吧！</Message>
      ) : (
        <>
          <ListGroup variant="flush">
            {cartItems.map((item) => (
              <ListGroup.Item key={item._id}>
                <Row className="align-items-center gy-2">
                  <Col xs={3} md={2}>
                    <Image src={item.image} alt={item.name} fluid rounded />
                  </Col>
                  <Col xs={9} md={3}>
                    <Link to={`/product/${item._id}`}>{item.name}</Link>
                  </Col>
                  <Col xs={4} md={2}>{formatNTD(item.price)}</Col>
                  <Col xs={5} md={3}>
                    <Form.Select
                      aria-label={`${item.name} 的數量`}
                      value={item.qty}
                      onChange={(e) => updateQtyHandler(item, Number(e.target.value))}
                    >
                      {[...Array(item.countInStock).keys()].map((x) => (
                        <option key={x + 1} value={x + 1}>
                          {x + 1}
                        </option>
                      ))}
                    </Form.Select>
                  </Col>
                  <Col xs={3} md={2} className="text-end text-md-start">
                    <Button
                      type="button"
                      variant="light"
                      onClick={() => removeHandler(item._id)}
                      aria-label={`移除 ${item.name}`}
                    >
                      <FaTrash />
                    </Button>
                  </Col>
                </Row>
              </ListGroup.Item>
            ))}
          </ListGroup>

          <div className="op-cart-footer">
            <span className="op-cart-subtotal" data-testid="cart-subtotal">
              小計（{itemCount} 件）：{' '}
              <strong>{formatNTD(itemsPrice)}</strong>
            </span>
            <Button type="button" variant="success" onClick={() => scrollTo?.('shipping')}>
              下一步：填寫運送資訊 →
            </Button>
          </div>
        </>
      )}
    </>
  );
};

export default CartSection;
